/** Compares two objects basing on their string representations */
function jsonEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
export default jsonEqual;